import App from './App.svelte';
import './styles/global.css';
import { applyAppSettingsToDocument } from './lib/app-settings.js';
import { getCachedAppSettings } from './lib/storage.js';

// Тема/шрифт из кэша ДО монтажа: без этого пользователь светлой (или системной
// светлой) темы на каждом холодном старте видел тёмный экран загрузки, а затем
// перекраску (актуальные настройки придут с бэка в initApp и перезапишут кэш).
try {
  applyAppSettingsToDocument(getCachedAppSettings() || {});
} catch (_) {
  // best effort — при сбое остаётся тёмная тема из :root
}

let app = null;
let appMounted = false;

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function renderFatalError(error) {
  const target = document.getElementById('app');
  if (!target || appMounted) {
    return;
  }

  const message = escapeHtml(error?.message || 'Не удалось запустить приложение.');
  target.innerHTML = `
    <main class="app fatal-error">
      <section class="fatal-error__content">
        <h1>Ошибка запуска</h1>
        <p>${message}</p>
        <button type="button" data-reload>Перезагрузить</button>
      </section>
    </main>
  `;

  target.querySelector('[data-reload]')?.addEventListener('click', () => {
    window.location.reload();
  });
}

window.addEventListener('error', (event) => {
  renderFatalError(event.error || new Error(event.message));
});

window.addEventListener('unhandledrejection', (event) => {
  renderFatalError(event.reason);
});

// Service worker: app-shell кэш для offline-режима (sw.template.js → dist/sw.js при
// сборке; versioned-кэш, без skipWaiting — см. комментарии в шаблоне). Регистрируем
// только в production-сборке (в dev sw.js не существует и SW только мешал бы HMR) и
// после window.load — не конкурируем с bootstrap за сеть/CPU на iOS.
// План отката: sw-killswitch.template.js → dist/sw.js (nginx отдаёт sw.js с no-cache).
// Тап по push-уведомлению (7.5): SW фокусирует окно и просит открыть чат.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    const data = event.data || {};
    if (data.type === 'push-open' && typeof data.url === 'string' && data.url.startsWith('/#/')) {
      window.location.hash = data.url.slice(1);
    }
  });
}

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Принудительная проверка новой версии SW при каждом старте: iOS может долго
        // не перепроверять sw.js сам, оставляя устройство на старом precache.
        registration.update().catch(() => {});
      })
      .catch((error) => {
        console.warn('Не удалось зарегистрировать service worker', error);
      });
  });
}

try {
  const target = document.getElementById('app');
  if (!target) {
    throw new Error('Контейнер приложения не найден.');
  }

  app = new App({ target });
  appMounted = true;
} catch (error) {
  console.error('Application bootstrap failed', error);
  renderFatalError(error);
}

export default app;
